<template>
  <section
    class="inline-flex w-full flex-col items-center justify-center py-14 lg:py-24"
    :class="{[`${colorValriants[backgroundColor]}`]: backgroundColor}"
  >
    <article class="gn-container flex-col items-center gap-7 lg:gap-20">
      <slot />
    </article>
  </section>
</template>

<script setup>
defineProps({
  backgroundColor: {
    type: [String, Boolean],
    default: false
  }
})

const colorValriants = {
  gray: 'bg-slate-50',
  darkGray: 'bg-slate-500'
}
</script>

<style lang="scss" scoped></style>
